export default __webpack_public_path__ + "529332108ef52356fb01142a65ba2472.png";